// Services/fetchResetPassword.js
import { USERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchResetPassword = async (body) => {
  const method = "POST";
  const response = await ApiRequestInterceptor(USERS.resetPassword, method, body);

  if (response.code === 200) {
    return { statusCode: 200, message: response.message || "Contraseña actualizada correctamente" };
  }

  if (response.code === 400) {
    return { statusCode: 400, message: response.message || "Token inválido o expirado" };
  }

  return { statusCode: response.code || 500, message: response.message || "Error al restablecer contraseña" };
};